<template>
    <div :class="`convention-teaser-tools`">
        <v-switch
            class="switch"
            v-model="alert"
            hide-details
            color="#0052FF"
            inset
            dense
            :label="label"
            :loading="loading"
            v-if="canSubscribe"
            @change="changeSubscription()"
        ></v-switch>
        <convention-select-action :parentConvention="parentConvention" :user="user" />
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import userMixin from "src/mixins/user";
import ConventionSelectAction from "../ConventionSelectAction.vue";

export default {
    props: ["parentConvention", "user"],
    components: { ConventionSelectAction },
    data() {
        return {
            alert: this.hasSubscribed(this.parentConvention),
            showConfirm: false,
            loading: false,
        };
    },
    mixins: [userMixin],
    watch: {
        user() {
            this.alert = this.hasSubscribed(this.parentConvention);
        },
    },
    methods: {
        async changeSubscription() {
            this.loading = true;
            if (this.alert) {
                if (this.canSubscribeConvention) {
                    await this.updateConventionSubscription(this.parentConvention, true);
                } else {
                    this.$nextTick(() => (this.alert = false));
                    EventBus.$emit("alert:error", {
                        message: "Vous avez atteint votre quota d'alertes email",
                        closable: false,
                    });
                }
            } else {
                await this.updateConventionSubscription(this.parentConvention, false);
            }
            this.loading = false;
        },
        remove() {
            this.removeConvention(this.parentConvention);
            this.showConfirm = false;
        },
    },
    computed: {
        label() {
            return "Recevoir la veille par email";
        },
    },
};
</script>

<style lang="sass">
.convention-teaser-tools
    padding: 0 0 5px 0
    display: flex
    flex-direction: row
    align-items: center
    justify-content: flex-end

    .switch
        margin-top: 0
        padding-top: 0

    .v-input--selection-controls__input
        position: relative
        top: 1px
        margin-right: 5px

    .v-label
        font-size: 12px
        color: $color-main

    .action
        margin-left: $grid-gutter
        outline: transparent

    .delete
        position: relative
        top: 1px

    .theme--light.v-icon
        color: $color-main
</style>
